/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Job_Form_Slot_Generation_Remove_ConfirmInputs */

const en_job_form_slot_generation_remove_confirm = /** @type {(inputs: Job_Form_Slot_Generation_Remove_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.count} selected appointments?`)
};

const de_job_form_slot_generation_remove_confirm = /** @type {(inputs: Job_Form_Slot_Generation_Remove_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ausgewählte Termine entfernen?`)
};

/**
* | output |
* | --- |
* | "Remove {count} selected appointments?" |
*
* @param {Job_Form_Slot_Generation_Remove_ConfirmInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_form_slot_generation_remove_confirm = /** @type {((inputs: Job_Form_Slot_Generation_Remove_ConfirmInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Slot_Generation_Remove_ConfirmInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_slot_generation_remove_confirm(inputs)
	return en_job_form_slot_generation_remove_confirm(inputs)
});